export enum INTEGRATED_SHIPMENT_DETAIL_VIEW_TAB {
  Details = 'details',
  GpsEvents = 'gps-events',
  Documents = 'documents',
  AuditTrail = 'audit-trail',
  Exceptions = 'exceptions',
}
